import Grid from '@material-ui/core/Grid'
import grey from '@material-ui/core/colors/grey'
import * as React from 'react'

import Box, { BoxProps } from './Box'
import Color from './Color'

export interface ScaleColor {
  name: string
  color: string
  textColor: string
}

export type StyledGrayscale = {
  primary?: boolean
}

export type ScaleProps = BoxProps & StyledGrayscale

const grayColor: ScaleColor[] = [
  {
    name: 'Gray 300',
    color: grey[300],
    textColor: '#222'
  },
  {
    name: 'Gray 400',
    color: grey[400],
    textColor: '#222'
  },
  {
    name: 'Gray 500',
    color: grey[500],
    textColor: '#222'
  },
  {
    name: 'Gray 600',
    color: grey[600],
    textColor: '#fff'
  },
  {
    name: 'Gray 700',
    color: grey[700],
    textColor: '#fff'
  },
  {
    name: 'Gray 800',
    color: grey[800],
    textColor: '#fff'
  },
  {
    name: 'Gray 900',
    color: grey[900],
    textColor: '#fff'
  }
]

const primaryColor: ScaleColor[] = [
  {
    name: 'Primary 300',
    color: Color.primary[300],
    textColor: '#222'
  },
  {
    name: 'Primary 400',
    color: Color.primary[400],
    textColor: '#222'
  },
  {
    name: 'Primary 500',
    color: Color.primary[500],
    textColor: '#222'
  },
  {
    name: 'Primary 600',
    color: Color.primary[600],
    textColor: '#222'
  },
  {
    name: 'Primary 700',
    color: Color.primary[700],
    textColor: '#222'
  },
  {
    name: 'Primary 800',
    color: Color.primary[800],
    textColor: '#fff'
  },
  {
    name: 'Primary 900',
    color: Color.primary[900],
    textColor: '#fff'
  }
]

const BoxGrayscale: React.FC<ScaleProps> = (props) => {
  const { primary } = props
  const getScaleBox = () => {
    if (primary) {
      return primaryColor
    } else {
      return grayColor
    }
  }

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      {getScaleBox().map((scaleColor, index) => (
        <Box
          key={`box-scale-${index}`}
          children={scaleColor.name}
          bgcolor={scaleColor.color}
          color={scaleColor.textColor}
          boxShadow="1"
          width="134px"
          height="62px"
          textAlign="center"
        />
      ))}
    </Grid>
  )
}

export default BoxGrayscale
